angular.module("taxWizard").classy.controller({
    name: "TaxWizardController",
    inject: [
        "$scope",
        "$sce",
        "DocumentsModelService",
        "SchoolModelService",
        "$rootScope",
        "standardCudArrayFactory",
        "authServiceFactory"
    ],
    init: function() {
        const schoolCountry = this.SchoolModelService.get()[0].School_Country;
        const schoolID = this.authServiceFactory.getAuth().schoolID;
        let domain = this.authServiceFactory.getDomain();

        switch (schoolCountry) {
            case "CAN":
                this.$.modalURL = `${domain}/family_side/faTaxWizCaDemo.php?ID=${schoolID.trim()}&done=2`;
                break;
            case "USA":
            default:
                this.$.modalURL = `${domain}/family_side/faTaxWizDemo.php?ID=${schoolID.trim()}&done=2`;
        }

        this.$.modalURL = this.$sce.trustAsResourceUrl(this.$.modalURL);
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.arrayCud = new this.standardCudArrayFactory(
            this.DocumentsModelService,
            schoolID,
            this.DocumentsModelService.get(),
            this,
            ["items"]
        );
        this.$.DocumentsModelService = this.DocumentsModelService;
        this.$rootScope.model = this.DocumentsModelService;
    }
});
